import dt from 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

$(document).ready(function() {
  $('.datatable').DataTable({
    "info": false,
    "bPaginate": false,
  });
})
